export const DepotTypes = {
  UNDERAGE: "underage"
};
